<template>
    <a-input
        v-model="changeValue"
        :type="parameters.type"
        :clearable="parameters.clearable"
        :maxLength="maxLength"
        :class="{ 'input-word-limit': parameters.isShowMax && maxLength !== Infinity }"
        @blur="onBlur"
        @focus="onFocus"
        @keyup.17="onKeyUp"
        @keypress="onKeyPress"
        @paste="onPaste"
        @change="onChange"
        :placeholder="parameters.placeholder">
        <template v-if="parameters.isShowMax && maxLength !== Infinity" v-slot:suffix>
            <span style="opacity: 0.6">{{ `${changeValue.length}/${maxLength}` }}</span>
        </template>
    </a-input>
</template>

<script>
import { DataEntryMixin } from "./mixins";
import { encryptedRender } from "@/utils/dynamic";

export default {
    name: "SdEncryptFieldInput",
    mixins: [DataEntryMixin],
    data() {
        return {
            isFocus: false, // 是否处于焦点状态
            isValidTrue: true, // 校验是否正确
            originValHidden: "",
            originVal: "",
            isEncryptField: true, // 是否需要加密
        };
    },
    computed: {
        maxLength() {
            return this.parameters.maxLength || this.parameters.maxLength === 0 ? (this.parameters.maxLength < 128 || this.parameters.maxLength === 128 ? this.parameters.maxLength : 128) : Infinity;
        },
        // 是否可编辑
        isModify({ $props }) {
            return Boolean($props.field.isModify);
        },
        changeValue: {
            get() {
                if (!this.isFocus && this.isValidTrue) {
                    if (!this.originVal) {
                        this.originVal = this.value;
                    }
                    if (this.isEncryptField) {
                        console.log(57, this.originVal);
                        // this.originVal = encryptedRender(this.originVal);
                        console.log(58, this.originVal);

                        return encryptedRender(this.originVal);
                    } else {
                        return this.originValHidden;
                    }
                } else {
                    console.log("gaiaigiaigiai", this.originValHidden, this.field.fieldFormType);
                    // this.originVal = this.originValHidden;
                    // console.log(60, this.originValHidden);
                    return this.originValHidden;
                    // return encryptedRender(this.originValHidden);
                }
            },

            set(val) {
                console.log(65, val);
                if (["input"].includes(this.field.fieldFormType)) {
                    this.originValHidden = val.trim();
                    this.$emit("update:value", val.trim());
                    this.$forceUpdate();
                }
            },
        },
    },
    methods: {
        updateValue(e) {
            console.log(77, e.target.value);
            this.$emit("update:value", e.target.value);
        },
        onBlur() {
            this.isFocus = false;
            this.$emit("onValidate");
        },
        onFocus() {
            this.isFocus = true;
        },
        onKeyPress() {
            // 代表有變動過，到保存之前都不加密
            console.log("11111111111");
            this.isEncryptField = false;
               this.$emit('change:fieldCoed')
        },
        onKeyUp() {
            // 代表有變動過，到保存之前都不加密
            this.isEncryptField = false;
               this.$emit('change:fieldCoed')
        },
        onPaste() {
            // 代表有變動過，到保存之前都不加密
            this.isEncryptField = false;
            console.log("粘貼");
               this.$emit('change:fieldCoed')
        },
        onChange() {
            this.isEncryptField = false;
        },
        // validatePromise(val){
        //     console.log('值 ====》', val);
        //     if(val){
        //         if(!this.originValHidden){
        //             this.$emit('update:value', this.originVal);
        //             this.$forceUpdate();
        //         }
        //         else{
        //             this.$emit('update:value', this.originValHidden);
        //             this.$forceUpdate();
        //             this.originVal = this.value;
        //         }
        //         this.isValidTrue = true;
        //     }
        //     else{
        //         this.$emit('update:value', this.originVal);
        //         this.$forceUpdate();
        //         this.isValidTrue = false;
        //     }
        // }
    },
};
</script>

<style scoped lang="less"></style>
